var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2222_156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.86239,
    y: 0.240072,
    width: 23.2752,
    height: 29.8333,
    rx: 0.583336,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.166668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50024,
    y: 13.4495,
    width: 17.9996,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50024,
    y: 16.5107,
    width: 17.9996,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50024,
    y: 19.5723,
    width: 17.9996,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50024,
    y: 22.6335,
    width: 12.7997,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.812 6.62695V7.04688C12.812 7.60352 12.812 8.22852 12.6313 9.1709L12.0063 9.10742C12.1748 8.26758 12.1821 7.64258 12.187 7.12012H9.56981V6.62695H12.812ZM13.2026 9.63477V10.1426H9.14989V9.63477H10.6001V8.10645H11.2202V9.63477H13.2026ZM17.5386 9.6543V10.1523H13.4712V9.6543H15.1704V8.64844H15.7905V9.6543H17.5386ZM15.81 6.8125C15.81 7.44727 16.3813 8.11621 17.397 8.27246L17.1333 8.79004C16.352 8.64844 15.771 8.23096 15.478 7.67676C15.185 8.22852 14.6089 8.65088 13.8325 8.79004L13.5688 8.27246C14.5747 8.11621 15.1411 7.44238 15.146 6.8125V6.49512H15.81V6.8125ZM20.3169 6.53906V7.03711H19.4331C19.438 7.55469 19.748 8.05518 20.4585 8.2627L20.1606 8.75098C19.6699 8.60205 19.3306 8.3042 19.1352 7.9209C18.9375 8.37012 18.5762 8.72656 18.0415 8.90234L17.7241 8.40918C18.4614 8.17725 18.7934 7.60107 18.8032 7.03711H17.895V6.53906H20.3169ZM21.3179 6.24121V7.27148H21.9184V7.7793H21.3179V8.87793H20.6929V6.24121H21.3179ZM19.8628 8.96582C20.7856 8.96094 21.3618 9.27832 21.3618 9.82031C21.3618 10.3623 20.7856 10.6846 19.8628 10.6846C18.9204 10.6846 18.3393 10.3623 18.3393 9.82031C18.3393 9.27832 18.9204 8.96094 19.8628 8.96582ZM19.8628 9.44922C19.2768 9.44922 18.9595 9.57129 18.9643 9.82031C18.9595 10.0742 19.2768 10.2012 19.8628 10.2012C20.439 10.2012 20.7466 10.0742 20.7466 9.82031C20.7466 9.57129 20.439 9.44922 19.8628 9.44922Z",
    fill: "#374969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2222_156",
    x: -1.5,
    y: 0.156738,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2222_156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2222_156",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaint);
export default __webpack_public_path__ + "static/media/IcComplaint.6e146f11de5c6cedeeed5ac7ee58f229.svg";
export { ForwardRef as ReactComponent };